// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniWidget_container__ZIe4w"};